export default "__VITE_ASSET__1UyKvayH__"